import RosterBackendService from './RosterBackendService';
import {
    TestAheadCourseAccessDTO, TestAheadCourseAccessRequest
} from '@beable/roster-backend-client-v1';

async function getTestAheadCourses(siteId?: number) {
    const request = siteId ? { siteId } : {};
    const response = await RosterBackendService.getTestAheadCourses(request);
    if (response.isOk()) {
        return response.value;
    }

    return null;
}

async function getTestAheadCourseAccess(siteId: number, courseId: string, orgId?: string) {
    const request: TestAheadCourseAccessRequest = { siteId, courseId, orgId }
    const response = await RosterBackendService.getTestAheadCourseAccess(request);
    if (response.isOk()) {
        return response.value;
    }

    return [];
}

async function saveTestAheadCourseAccess(siteId: number, courseId: string, accessSelections: string, orgId?: string) {
    const request: TestAheadCourseAccessDTO = { siteId, courseId, orgId, access: { selections: accessSelections } }
    const response = await RosterBackendService.saveTestAheadCourseAccess(request);
    if (response.isOk()) {
      return response.value;
    }

    return false;
}

async function deleteTestAheadCourseAccess(siteId: number, courseId: string, orgId?: string) {
    const request: TestAheadCourseAccessRequest = { siteId, courseId, orgId }
    const response = await RosterBackendService.deleteTestAheadCourseAccess(request);
    if (response.isOk()) {
        return response.value;
    }

    return false;
}

export default {
    getTestAheadCourses, getTestAheadCourseAccess, saveTestAheadCourseAccess, deleteTestAheadCourseAccess,
}
